var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtomoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94,
    height: 13,
    viewBox: "0 0 94 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .226v10.161h10.164V.226H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#142355",
    d: "M14.235.713l-.435 2.38h3.745l-1.46 8.34h2.909l1.46-8.34h3.789l.435-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C82814",
    d: "M50.696.714l-3.52 3.58-2.28-3.58H42.2l-1.877 10.722h2.766l1.141-6.553 1.714 2.985h1.36l2.659-2.958-1.134 6.526h2.766L53.473.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#142355",
    d: "M69.486.713l-.436 2.38h3.745l-1.46 8.34h2.909l1.46-8.34h3.79l.435-2.38z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5 -.108)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C82814",
    d: "M1.738 10.387a5.963 5.963 0 0 1 .005-8.422 5.96 5.96 0 0 1 8.42.005l-2.102 2.1a2.985 2.985 0 0 0-4.217-.002 2.987 2.987 0 0 0-.002 4.219l-2.104 2.1z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#142355",
    d: "M10.666 1.863a5.962 5.962 0 0 1-.004 8.422 5.96 5.96 0 0 1-8.421-.004l2.102-2.102a2.986 2.986 0 0 0 4.219.003 2.987 2.987 0 0 0 .001-4.218l2.103-2.101zM27.883 10.28a5.963 5.963 0 0 1 .006-8.423 5.96 5.96 0 0 1 8.42.004l-2.103 2.1a2.985 2.985 0 0 0-4.217-.001 2.987 2.987 0 0 0-.002 4.218l-2.104 2.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C82814",
    d: "M36.311 1.863a5.962 5.962 0 0 1-.004 8.422 5.96 5.96 0 0 1-8.421-.004l2.102-2.102a2.986 2.986 0 0 0 4.219.003 2.987 2.987 0 0 0 .001-4.218l2.103-2.101zM57.488 10.28a5.963 5.963 0 0 1 .005-8.423 5.96 5.96 0 0 1 8.42.004l-2.102 2.1a2.985 2.985 0 0 0-4.217-.001 2.987 2.987 0 0 0-.002 4.218l-2.104 2.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#142355",
    d: "M65.916 1.863a5.962 5.962 0 0 1-.004 8.422 5.96 5.96 0 0 1-8.421-.004l2.102-2.102a2.986 2.986 0 0 0 4.218.003 2.987 2.987 0 0 0 .002-4.218l2.103-2.101zM83.133 10.28a5.963 5.963 0 0 1 .005-8.423 5.96 5.96 0 0 1 8.42.004l-2.102 2.1a2.985 2.985 0 0 0-4.217-.001 2.987 2.987 0 0 0-.003 4.218l-2.103 2.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C82814",
    d: "M91.56 1.863a5.962 5.962 0 0 1-.003 8.422 5.96 5.96 0 0 1-8.422-.004l2.103-2.102a2.986 2.986 0 0 0 4.218.003 2.987 2.987 0 0 0 .002-4.218l2.103-2.101z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtomoto);
export default __webpack_public_path__ + "static/media/otomoto.d32b3c9a92c086380192ebd321e63621.svg";
export { ForwardRef as ReactComponent };